import React from 'react';
import { Route } from 'react-router'
import { Redirect } from 'react-router-dom'


export default class App extends React.Component {
    render() {
      const {
        authenticated,
        component: Component,
        ...props
      } = this.props
      return (
        <Route
          {...props}
          render={props =>
            authenticated
              ? <Component {...props} />
              : (
              <Redirect to={{
                pathname: '/sign/sign-in',
                state: { from: props.location }
              }} />
            )
          }
        />
      )
    }
  }



// WEBPACK FOOTER //
// ./src/pages/sign/containers/sign.js